"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupLiquidityExtension = void 0;
const stargate_1 = require("@cosmjs/stargate");
const long_1 = __importDefault(require("long"));
const query_1 = require("../codec/cyber/liquidity/v1beta1/query");
function setupLiquidityExtension(base) {
    const rpc = (0, stargate_1.createProtobufRpcClient)(base);
    // Use this service to get easy typed access to query methods
    // This cannot be used for proof verification
    const queryService = new query_1.QueryClientImpl(rpc);
    return {
        liquidity: {
            params: async () => {
                const response = await queryService.Params({});
                return response;
            },
            pool: async (id) => {
                const response = await queryService.LiquidityPool({
                    poolId: long_1.default.fromNumber(id),
                });
                return response;
            },
            pools: async () => {
                const response = await queryService.LiquidityPools({
                    pagination: undefined,
                });
                return response;
            },
        },
    };
}
exports.setupLiquidityExtension = setupLiquidityExtension;
//# sourceMappingURL=liquidity.js.map